export default {
    /* c - correlation id
     * r - response code
     */
    PinRequest: {
        datapoint: {
            name: 'ExtPinRequest',
            customData: (c: string, r: number) => [c, r],
        },
    },

    PersistedAddinMigration: {
        datapoint: {
            name: 'ExtPersistedAddinMigration',
            customData: (addinTypes: string) => [addinTypes],
        },
    },
};
